import { render, staticRenderFns } from "./AcademyLaw.vue?vue&type=template&id=0d7bad10&scoped=true"
import script from "./AcademyLaw.vue?vue&type=script&lang=ts"
export * from "./AcademyLaw.vue?vue&type=script&lang=ts"
import style0 from "./AcademyLaw.vue?vue&type=style&index=0&id=0d7bad10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7bad10",
  null
  
)

export default component.exports